import { useState, useRef, useEffect } from 'react'

const FILTER_OPTIONS = [
  { key: 'date',          label: '📅 Fecha de creación',     adminOnly: false },
  { key: 'include_ic',    label: '⭐ Incluir IC',              adminOnly: false },
  { key: 'exclude_ic',    label: '⭐ Excluir IC',              adminOnly: false },
  { key: 'include_flag',  label: '🚩 Incluir Flag',           adminOnly: false },
  { key: 'exclude_flag',  label: '🚩 Excluir Flag',           adminOnly: false },
  { key: 'exclude_camp',  label: '📢 Excluir campaña activa', adminOnly: false },
  { key: 'agent',         label: '👤 Filtrar por agente',     adminOnly: true },
]

/**
 * Dropdown que lista los filtros NO activos. Click en uno llama onAddFilter(key).
 *
 * @param {string[]} activeKeys - Keys de filtros ya activos (no se muestran)
 * @param {Function} onAddFilter - (key) => void
 * @param {boolean} isAdmin
 */
export default function AddFilterDropdown({ activeKeys, onAddFilter, isAdmin }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [])

  const available = FILTER_OPTIONS.filter(
    opt => !activeKeys.includes(opt.key) && (!opt.adminOnly || isAdmin)
  )

  if (available.length === 0) return null

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(o => !o)}
        className="px-3 py-1.5 text-sm bg-white dark:bg-gray-800 border border-blue-300 dark:border-blue-700 text-blue-600 dark:text-blue-400 rounded-full hover:bg-blue-50 dark:hover:bg-blue-900/30 transition-colors"
        type="button"
      >
        + Agregar filtro ▾
      </button>
      {open && (
        <div className="absolute left-0 top-full mt-1 w-56 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-50">
          {available.map(opt => (
            <button
              key={opt.key}
              onClick={() => { onAddFilter(opt.key); setOpen(false) }}
              className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 first:rounded-t-lg last:rounded-b-lg"
              type="button"
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
